// src/features/practitioner/import/UploadStep.jsx
import React from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";
import ExcelUploadCard from "./ExcelUploadCard";
import { InfoAlert } from "../utils";
import { useAppContext } from "providers/AppProvider";
import { useSelector } from "react-redux";

const UploadStep = ({
  control,
  watch,
  setValue,
  errors,
  setExcelData,
  setIsExcelValid,
  setValidationErrors,
}) => {
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/PractitionerListTemplate.xlsx";
    link.setAttribute("download", "PractitionerListTemplate.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const {
    config: { theme },
  } = useAppContext();

  const { allPermissionType } = useSelector((state) => state.role);
  const practitionerSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Practitioner"
  );

  return (
    <Row>
      <Col xs={12}>
        <InfoAlert>
          Download the template, fill it with your practitioner data, then
          upload it here. The system will validate your data before import.
        </InfoAlert>
      </Col>

      <Row className="d-flex align-items-stretch">
        <Col xs={12} md={6}>
          <Card className="">
            <Card.Body className="text-center d-flex flex-column">
              <div className="mb-4">
                <div
                  className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center mb-3 justify-content-center mx-auto"
                  style={{ width: 80, height: 80 }}
                >
                  <Download size={28} />
                </div>
                <h5 className="fw-bold mb-2">Excel Template</h5>
                <p className="text-muted mb-4">
                  Download our preformatted Excel template to ensure your data
                  is structured correctly
                </p>
              </div>
              <div className="mt-auto">
                <Button
                  variant="primary"
                  className="d-flex align-items-center justify-content-center mx-auto"
                  onClick={handleDownloadTemplate}
                >
                  Download Template
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} className="mb-4">
          {!!practitionerSetting?.import ? (
            <ExcelUploadCard
              watch={watch}
              theme={theme}
              control={control}
              errors={errors}
              setValue={setValue}
              setIsExcelValid={setIsExcelValid}
              setExcelData={setExcelData}
              setValidationErrors={setValidationErrors}
              name="excelFile"
            />
          ) : (
            <div className="text-center py-6">
              You don't have a permission to import practitioner
            </div>
          )}
        </Col>
      </Row>
    </Row>
  );
};

export default UploadStep;
